import React , {useState} from 'react'
import {  updateDoc  , collection, getFirestore, query , deleteDoc , doc} from 'firebase/firestore'
import { initializeApp } from 'firebase/app'
import Swal  from 'sweetalert2';
import { Link } from 'react-router-dom';








function Progress(targets , name) {
  const [showControls , setShowControls] = useState(false)
  const firebaseConfig = {
    apiKey: "AIzaSyDHYl0WYOlyq4fglpu3uZqV1LAuv6_5QvM",
    authDomain: "to-do-list-app-7aa20.firebaseapp.com",
    projectId: "to-do-list-app-7aa20",
    storageBucket: "to-do-list-app-7aa20.appspot.com",
    messagingSenderId: "388979404562",
    appId: "1:388979404562:web:e4df2225ac4d9b96408dcb"
  };


  initializeApp(firebaseConfig)

  // init services
  const db = getFirestore()
  // collection Ref
  const colRef = collection(db , `${window.localStorage.getItem("Name")}-targets`)
  
  const handleFinished = f => {
    console.log(f.progress , f.deleted)
    
    const docRef = doc(colRef , `${f.id}` )

    updateDoc(docRef , {
      inProgress : false ,
      finished : true
    });
    Swal.fire({
      position: 'center',
      imageUrl: 'https://thumbs.gfycat.com/EarnestSmartGrayreefshark-max-1mb.gif',
      imageWidth: 400,
      imageAlt: 'Custom image',
      showConfirmButton: false,
      showCloseButton : true
    })
  }

  const handleCanceled = d => {
    console.log(d.progress , d.deleted)
    
    const docRef = doc(colRef , `${d.id}` )

    updateDoc(docRef , {
      inProgress : false ,
      deleted : true
    });
    Swal.fire({
      imageUrl : "https://media.tenor.com/HuWQuPYxalgAAAAd/%D8%A8%D9%87%D8%AC%D8%AA%D8%B5%D8%A7%D8%A8%D8%B1-%D8%A8%D9%87%D8%AC%D8%AA.gif" ,
      showConfirmButton: false,
      showCloseButton : true
    })
  }
  const handleDelay = dl => {
    console.log(dl.progress , dl.deleted)
    
    const docRef = doc(colRef , `${dl.id}` )

    updateDoc(docRef , {
      inProgress : false ,
      delayed : true
    });
    Swal.fire({
      icon : 'warning' ,
      text : "لا تؤجل قرف اليوم مع قرف الغد عشان هي مش ناقصه" ,
      showConfirmButton: false,
      showCloseButton : true
    })
}
  const handleRemove = re => {
    console.log(re.progress , re.deleted)
    
    const docRef = doc(colRef , `${re.id}` )

    deleteDoc(docRef);
    Swal.fire({
    position: 'center',
    imageUrl : "https://thumbs.gfycat.com/DarkMeatyAegeancat-size_restricted.gif",
    text : "خلاص اتحذفت يكش تخلص حاجه" ,
    showConfirmButton: false,
    showCloseButton : true
  })
}

  return (
    <div className="notes progressEle">
      <div className="container">
        <div className="content">
          <div className="top alert alert-secondary">
            <h1>Tasks In progress</h1>
            {targets.targets.filter(f => f.inProgress === true).length !== 0 && (
              <button className="controlSet" onClick={()=> setShowControls(!showControls)}>
                <img src="https://cdn-icons-png.flaticon.com/512/627/627495.png" alt="" title='control button' />
              </button>
            )}
          </div>
          {targets.targets.filter(f => f.inProgress === true).length === 0 && 
            <div className="alerting unfinished">
              <div className="alert alert-secondary">
                <h3>No Task in progress!! <br /> Are You dead?</h3>
                <img src="https://thumbs.gfycat.com/CoolHarmlessHarborseal-max-1mb.gif" alt="not progress" />
                <button>
                  <Link to='/notes/addtask' >
                    Add task now
                  </Link>
                </button>
              </div>
            </div>
          }
          <div className="bottom">
            {targets.targets.filter(f => f.inProgress === true).map(p => (
              <div key={p.id} className="tab">
                <h3 dir='auto'>{p.Target}</h3>
                <p dir='auto'>{p.Description}</p>
                {showControls === true && (
                  <div className="options prog-opt" >
                    <div className="cont">
                      <button title='cancel it now' onClick={()=> handleCanceled(p)}>
                        <img src="https://cdn-icons-png.flaticon.com/512/3221/3221897.png" alt="cancel it now" />
                      </button>
                      <button  title='finished' onClick={() => handleFinished(p)}>
                        <img src="https://cdn-icons-png.flaticon.com/512/214/214353.png" alt="done" />
                      </button>
                      <button  title='delay it' onClick={() => handleDelay(p)}>
                        <img src="https://cdn-icons-png.flaticon.com/512/4128/4128030.png" alt="delay" />
                      </button>
                      <button  title='remove it' className='remove-button' onClick={() => handleRemove(p)}>
                        <img src="https://cdn-icons-png.flaticon.com/512/594/594598.png" alt="remove" />
                      </button>
                    </div>
                  </div>
                )}
              </div>
            ))}
          </div>
        </div>
      </div>
    </div>
  )
}

export default Progress